import Seo from '@/common/components/layouts/seo';
import Text from '@/common/components/atom/text';

/**
 * DR-43. `/s/<city>/<specialty>/<area>` that answered 404 (a neighbourhood with too few doctors of that specialty for
 * a page, or a slug that does not exist) — so the text never claims «no doctor here», only that this page is not there. Still HTTP 404, noindex — but a person lands here from a link or from Google, so it says
 * what is true and links to the page that has doctors. Only for area URLs; every other 404 stays the default.
 */
export const AreaNotFound = ({ city, gexp, host }: { city: string; gexp: string; host?: string }) => (
  <>
    <Seo title="صفحهٔ این محله پیدا نشد" noIndex host={host} />
    <div data-testid="area-not-found" className="container flex flex-col items-center p-5 mx-auto space-y-4 text-center min-h-[50vh] justify-center">
      <Text as="h1" fontWeight="bold" fontSize="lg">
        صفحهٔ این محله برای این تخصص وجود ندارد
      </Text>
      <Text as="p" fontSize="sm" className="text-slate-600">
        پزشکان همین تخصص در بقیهٔ شهر را ببینید و نوبت بگیرید.
      </Text>
      <div className="flex flex-col w-full max-w-sm gap-2">
        <a
          href={`/s/${city}/${gexp}/`}
          className="inline-flex items-center justify-center min-h-[44px] px-5 text-sm font-medium text-white rounded-lg bg-primary"
        >
          همهٔ پزشکان این تخصص در شهر
        </a>
        <a
          href={`/s/${city}/`}
          className="inline-flex items-center justify-center min-h-[44px] px-5 text-sm font-medium bg-white border rounded-lg border-primary text-primary"
        >
          جستجوی پزشکان شهر
        </a>
      </div>
    </div>
  </>
);

export default AreaNotFound;
